import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@mantine/core';
import fabric1 from '../../assets/images/fabric-1.png';
import fabric2 from '../../assets/images/fabric-2.png';
import fabric3 from '../../assets/images/fabric-3.png';
import './AboutUltron.css';

const AboutUltron = () => {
    return (
        <div className='section'>
            <div className="inner-section" data-aos='fade-down'>
                <h3 className='section-title'>About FabInsta</h3>
                <h2 className='section-heading'>Discover the<br className='responsive-br' /> difference</h2>
            </div>
            <div className="about-details">
                <div className="about-title" data-aos='fade-down'>
                    <h2>Where</h2>
                    <p>quality meets <br/> reliability</p>
                </div>
                <div className="about-text" data-aos="zoom-in-down">
                    <Text size="md">
                       Welcome to FabInsta. Based in the heart of India's textile industry, Tirupur, FabInsta premier fabric sourcing company dedicated to providing a vast array of high-quality fabrics for men, women, kids wear. Our extensive selection includes everything from the latest trends in fashion fabrics to durable materials for school uniforms. At FabInsta, we pride ourselves on being the preferred choice for garment manufacturers seeking reliable and diverse fabric options. Our robust network of suppliers spans across India and abroad, ensuring that we can offer a comprehensive range of fabrics to meet the varied needs of our 8000+ clientele. Our commitment to excellence, innovation, and customer satisfaction sets us apart in the textile industry. We strive to build long-lasting relationships with our buyers and suppliers, delivering unparalleled service and quality with every transaction.
                    </Text>
                    <button className="read-more">
                        Explore More
                        <FontAwesomeIcon className='btn-icon' icon={faCircleArrowRight} />
                    </button>
                </div>
                <div className="images" data-aos='zoom-in'>
                    <div className='top-images'>
                        <img src={`${fabric1}?time=${Date.now()}`} alt="fabric1" className='image-1' />
                    </div>
                    <div className='bottom-images'>
                        <img src={`${fabric2}?time=${Date.now()}`} alt="fabric2" className='image-2' />
                        <img src={`${fabric3}?time=${Date.now()}`} alt="fabric3" className='image-3' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUltron;